import { render, staticRenderFns } from "./score-description-read.view.vue?vue&type=template&id=5fe101ab&scoped=true&"
import script from "./score-description-read.view.vue?vue&type=script&lang=ts&"
export * from "./score-description-read.view.vue?vue&type=script&lang=ts&"
import style0 from "./score-description-read.view.vue?vue&type=style&index=0&id=5fe101ab&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe101ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VProgressCircular,VRow})
